module.exports = __webpack_public_path__ + "ejicons.057bc5fa15bb2f5c1e43.svg";


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/fc0fc15e/0/notifi/notifi-web-site/~/syncfusion-javascript/Content/ej/web/material/icons/ejicons.svg?-dzszjm
// module id = ../../../../syncfusion-javascript/Content/ej/web/material/icons/ejicons.svg?-dzszjm
// module chunks = 2